import React, { useState, useEffect, useRef, Fragment } from "react";
import { Table, Row, Col, Tooltip } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import "flatpickr/dist/themes/material_blue.css";
import BreadcrumbLink from "../../../components/Common/BreadcrumbLink";
import i18n from "../../../i18n";
import { listRouteType } from "../../../common/data";
import Spinners from "../../../components/Common/Spinner";
import PaginationV2 from "../../../components/Pagination/PaginationV2";
import { getOrgsAdmin, getEmployeeBookings, getPreRequestService, postServicesAdmin } from "../../../helpers/api_rombo_helper";
import AlertSuccess from "../../../components/Alerts/AlertSuccess";
import AlertError from "../../../components/Alerts/AlertError";
import { createSelector } from "reselect";
import { FilterType, DataActions, UserType, ServiceStatus, TypeAddress, RoutingServiceType } from "../../../constants/enums";
import { orgId, handleSearchFilters } from "../../../constants/utils";
import folderNoResults from "../../../assets/images/questionmark-folder.png";
import RoutingMap from "../../Google/RoutingMap";
import Flatpickr from "react-flatpickr";
import { allowedHoursOptions } from "../../../constants/utils";
import { addressMapping, BASE_ADDRESSES_FULL, BASE_ADDRESSES_SHORT, originAddressOptions, normalizeAddress, isBaseAddress, getFullBaseAddress } from "./helpers";

const RoutingServices = (props) => {
  document.title = `${i18n.t("Routing")} - ${orgId}`;

  const dispatch = useDispatch();
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [selectedDestiny, setSelectedDestiny] = useState(null);
  const [selectedAddressDestiny, setSelectedAddressDestiny] = useState({});
  const [selectedAddressOrigin, setSelectedAddressOrigin] = useState({});
  const [addressesMarkers, setAddressesMarkers] = useState([]);
  const [showAddresses, setShowAddresses] = useState(false);
  const [showUnits, setShowUnits] = useState(false);
  const [showEmployees, setShowEmployees] = useState(false);
  const [arrScales, setArrScales] = useState([]);
  const [findEmployees, setFindEmployees] = useState([]);
  const [onFocusAddress, setOnFocusAddress] = useState("");
  const [titleAdressDestiny, setNameTitleDestiny] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Destiny"), address: "" }));
  const [titleAdressOrigin, setNameTitleOrigin] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Origin"), address: "" }));
  const [titleAdressArrScales, setNameTitleArrScales] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Scale"), address: "" }));
  const [titleAdressArrEmployees, setNameTitleEmployees] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Employee"), address: "" }));
  const [isPanelExpanded, setIsPanelExpanded] = useState(true);
  const [dateService, setDateService] = useState("");
  const [hourService, setHourService] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(6);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [tooltipOpen, setTooltipOpen] = useState({});
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedOriginAddress, setSelectedOriginAddress] = useState("");
  const [selectedServiceType, setSelectedServiceType] = useState("");
  const [showAlertError, setShowAlertError] = useState(false);
  const [errorHeader, setErrorHeader] = useState('');
  const [errorBody, setErrorBody] = useState('');
  const [isRouteSummaryPanelOpen, setIsRouteSummaryPanelOpen] = useState(false);
  const [showRouteSummaryPanel, setShowRouteSummaryPanel] = useState(false);
  const [estimatedTime, setEstimatedTime] = useState("");
  const [estimatedDistance, setEstimatedDistance] = useState("");
  const [recommendedRoutes, setRecommendedRoutes] = useState([]);
  const [selectedRouteIndex, setSelectedRouteIndex] = useState(-1);
  const [isCalculatingRoutes, setIsCalculatingRoutes] = useState(false);
  const [allOriginalRoutes, setAllOriginalRoutes] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const [routeColors] = useState([
    "#FF5F00",
    "#3B82F6",
    "#10B981",
    "#8B5CF6",
    "#EF4444",
    "#F59E0B"
  ]);

  const [isLoading, setLoading] = useState(true);
  const [findServices, setFindServices] = useState([]);
  const [listServices, setListServices] = useState({ page: 1, size: 10, pages: 1, items: [] });
  const [infoUser, setInfoUser] = useState({ permissions: [] });
  const [requestServiceCancelModal, setRequestServiceCancelModal] = useState(false);
  const toggleViewModalCancelService = () => setRequestServiceCancelModal(!requestServiceCancelModal);
  const [showNoResults, setShowNoResults] = useState(false);
  const [showAlertSuccess, setShowAlertSuccess] = useState(false);
  const [textHeader, setTextHeader] = useState('');
  const [textBody, setTextBody] = useState('');
  const [listCompanies, setListCompanies] = useState([]);
  const [key, setKey] = useState(0);
  const [panelError, setPanelError] = useState(false);
  const [previousValidState, setPreviousValidState] = useState({
    selectedServices: [],
    arrScales: [],
    addressesMarkers: []
  });

  const savedFilters = JSON.parse(localStorage.getItem("routingFilters")) || { data: { filters: {} } };

  const [fCompany, setFCompany] = useState(savedFilters.data?.filters?.partner_id || null);
  const [typeService, setTypeService] = useState(null);
  const [statusService, setStatusService] = useState(savedFilters.data?.filters?.status || null);
  const [reloadList, setReloadList] = useState(true);
  const [serviceNumber, setServiceNumber] = useState(savedFilters.data?.filters?.code || null);
  const [placeService, setPlaceService] = useState(savedFilters.data?.filters?.place_id || null);
  const [plateService, setPlateService] = useState(savedFilters.data?.filters?.plate || null);

  const [filtersOpts, setFiltersOpts] = useState({
    eventType: "sendMessage",
    metadata: { platform: "WEB", screen: "HISTORY" },
    data: { action: DataActions.GET_BOOKINGS, filters: { page: 1, size: 10 } }
  });
  
  const autoformik = useFormik({
    initialValues: {
      search: "",
      serviceNumber: "",
      plate: "",
      status: "",
      type: "",
      place_id: "",
    },
    validationSchema: Yup.object({
      search: Yup.string(),
      serviceNumber: Yup.string(),
      plate: Yup.string(),
      status: Yup.string(),
      type: Yup.string(),
      place_id: Yup.string(),
    })
  });

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, loading, data } = useSelector(LoginProperties);

  const userProfile = {
    username: data?.data?.full_name || 'Admin User',
    sub: data?.data?.id || 'admin-id'
  };

  const isEmployee = infoUser.roles === UserType.EMPLOYEE;

  const geocodeAddress = async (address) => {
    try {
      const geocoder = new window.google.maps.Geocoder();
      return new Promise((resolve, reject) => {
        geocoder.geocode({ address }, (results, status) => {
          if (status === 'OK' && results[0]) {
            const location = results[0].geometry.location;
            resolve({
              lat: location.lat(),
              lng: location.lng(),
              description: address
            });
          } else {
            reject(new Error('Geocoding failed'));
          }
        });
      });
    } catch (error) {
      console.error("Error en geocoding:", error);
      return null;
    }
  };

  useEffect(() => {
    const updateBaseAddress = async () => {
        if (!selectedOriginAddress) {
            setAddressesMarkers(prev => {
                const baseAddress = prev.find(marker => marker.isBase);
                return baseAddress ? [baseAddress] : [];
            });
            if (selectedOrigin?.isBase) {
                setSelectedOrigin(null);
                setSelectedAddressOrigin({});
            }
            if (selectedDestiny?.isBase) {
                setSelectedDestiny(null);
                setSelectedAddressDestiny({});
            }
            return;
        }
  
        const fullAddress = getFullBaseAddress(selectedOriginAddress);
        if (!fullAddress) return;
  
        try {
            const geocodedAddress = await geocodeAddress(fullAddress);
            if (!geocodedAddress) return;
  
            const addressMarker = {
                id: `base-${Date.now()}`,
                location: geocodedAddress,
                description: fullAddress,
                dragg: false,
                isBase: true
            };
  
            if (selectedServiceType === RoutingServiceType.AFORO) {
                addressMarker.typeAddress = TypeAddress.DESTINY;
                setSelectedDestiny(addressMarker);
                setSelectedAddressDestiny(addressMarker);
                setNameTitleDestiny(
                    i18n.t("TitleAddress", {
                        typeAddress: i18n.t("Destiny"),
                        address: fullAddress,
                    })
                );
                if (selectedOrigin?.isBase) {
                    setSelectedOrigin(null);
                    setSelectedAddressOrigin({});
                }
            } else {
                addressMarker.typeAddress = TypeAddress.ORIGIN;
                setSelectedOrigin(addressMarker);
                setSelectedAddressOrigin(addressMarker);
                setNameTitleOrigin(
                    i18n.t("TitleAddress", {
                        typeAddress: i18n.t("Origin"),
                        address: fullAddress,
                    })
                );
                if (selectedDestiny?.isBase) {
                    setSelectedDestiny(null);
                    setSelectedAddressDestiny({});
                }
            }

            setAddressesMarkers([addressMarker]);
  
        } catch (error) {
            console.error('Error actualizando dirección base:', error);
        }
    };
  
    updateBaseAddress();
}, [selectedOriginAddress, selectedServiceType]);

  useEffect(() => {
    const updatedMarkers = addressesMarkers.map(marker => ({
      ...marker,
      isSelected: selectedServices.includes(marker.serviceId)
    }));
    setAddressesMarkers(updatedMarkers);
  }, [selectedServices]);

  const onChangeDate = (e) => {
    const selectedDate = e[0];
    if (selectedDate) {
      setDateService(`${selectedDate.getFullYear()}-${(selectedDate.getMonth() + 1).toString().padStart(2, '0')}-${selectedDate.getDate().toString().padStart(2, '0')}`);
    } else {
      setDateService("");
    }
  };

  const handleSearch = async (page = 1) => {
    if (!hourService) {
      setSearchError(i18n.t("PleaseSelectHour"));
      return;
    }

    setIsSearching(true);
    setSearchError(null);
    setHasSearched(true);
    setCurrentPage(page);

    try {
      const formattedTime = `${hourService}:00`;
  
      const params = {
        origin: selectedOriginAddress,
        time: formattedTime,
        timezone: "America/Mexico_City",
        date: dateService,
      }
  
      const response = await getPreRequestService(token, params);

      if (response && response.items) {
        let filteredResults = response.items;
        
        if (selectedServiceType) {
          filteredResults = response.items.filter(service => {
            const serviceType = getServiceType(service);
            return serviceType === selectedServiceType;
          });
        }
  
        setSearchResults(filteredResults);
        setTotalItems(filteredResults.length);
        setTotalPages(Math.ceil(filteredResults.length / pageSize));
        createServiceMarkers(filteredResults);
      } else {
        setSearchResults([]);
        setTotalItems(0);
        setTotalPages(0);
        setSearchError(i18n.t("NoResultsFound"));
      }
    } catch (error) {
      console.error("Error searching for pre-applications:", error);
      setSearchError(error?.response?.data?.detail || error.message || i18n.t("SearchError"));
      setSearchResults([]);
      setTotalItems(0);
      setTotalPages(0);
    } finally {
      setIsSearching(false);
    }
  };

  const createServiceMarkers = async (services) => {
    const serviceMarkers = [];
    
    for (const service of services) {
      const address = getDisplayAddress(service);

      if (address && !isBaseAddress(address)) {
        const geocodedAddress = await geocodeAddress(address);
        if (geocodedAddress) {
          const isSelected = selectedServices.includes(service.id);
          const serviceType = getServiceType(service);
          
          serviceMarkers.push({
            id: `service-${service.id}`,
            location: geocodedAddress,
            description: address,
            typeAddress: TypeAddress.ARRAY_SCALES,
            dragg: true,
            isService: true,
            serviceId: service.id,
            serviceData: service,
            serviceType: serviceType,
            isSelected: isSelected
          });
        }
      } else {
        console.log(`Servicio ${service.id} omitido - dirección base:`, address);
      }
    }

    setAddressesMarkers(prev => {
      const nonServiceMarkers = prev.filter(marker => !marker.isService);
      return [...nonServiceMarkers, ...serviceMarkers];
    });
  };

  const handlePageChange = (newPage) => {
    handleSearch(newPage);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    
    try {
      const [year, month, day] = dateString.split('-').map(Number);
      const date = new Date(Date.UTC(year, month - 1, day));
      
      if (isNaN(date.getTime())) {
        return dateString;
      }
      
      return date.toLocaleDateString('es-MX', {
        timeZone: 'UTC',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch (error) {
      console.error("Error formateando fecha:", error, "Fecha original:", dateString);
      return dateString;
    }
  };

  const formatTime = (timeString) => {
    if (!timeString) return "";
    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'pm' : 'am';
    const formattedHour = hour % 12 || 12;
    return `${formattedHour}:${minutes} ${ampm}`;
  };

  const getServiceType = (service) => {
    const originDesc = service.origin?.address?.description || "";
    const destDesc = service.destination?.address?.description || "";
  
    const isOriginBase = isBaseAddress(originDesc);
    const isDestBase = isBaseAddress(destDesc);
  
    if (isOriginBase && !isDestBase) {
      return RoutingServiceType.DESAFORO;
    }
    
    if (isDestBase && !isOriginBase) {
      return RoutingServiceType.AFORO;
    }
    
    if (isOriginBase && isDestBase) {
      return RoutingServiceType.DESAFORO;
    }
    
    return RoutingServiceType.NORMAL;
  };

  const truncateText = (text, maxLength = 10) => {
    if (!text) return i18n.t("NoAddress");
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const getFullAddress = (service) => {
    return service.origin?.address?.description || 
           service.destination?.address?.description || 
           i18n.t("NoAddress");
  };

  const toggleTooltip = (index) => {
    setTooltipOpen(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const toggleSelectService = async (serviceId) => {
    const newSelectedServices = selectedServices.includes(serviceId)
      ? selectedServices.filter(id => id !== serviceId)
      : [...selectedServices, serviceId];

    if (newSelectedServices.length > 4) {
      setErrorHeader(i18n.t("LimitReached"));
      setErrorBody(i18n.t("MaxServicesSelected"));
      setShowAlertError(true);
      return;
    }

    setSelectedServices(newSelectedServices);
    const updatedMarkers = addressesMarkers.map(marker => 
      marker.serviceId === serviceId 
        ? { ...marker, isSelected: !marker.isSelected }
        : marker
    );
    setAddressesMarkers(updatedMarkers);

    if (newSelectedServices.length > 0) {
      const selectedServiceMarkers = updatedMarkers
        .filter(marker => newSelectedServices.includes(marker.serviceId) && marker.isService)
        .sort((a, b) => {
          const indexA = newSelectedServices.indexOf(a.serviceId);
          const indexB = newSelectedServices.indexOf(b.serviceId);
          return indexA - indexB;
        });
      
      setArrScales(selectedServiceMarkers);
      determineOriginAndDestination(selectedServiceMarkers);
  
      if (newSelectedServices.length >= 2) {
        const isValid = await validateManualRouteDuration(selectedServiceMarkers);
        if (!isValid) {
          const lastServiceId = selectedServiceMarkers[selectedServiceMarkers.length - 1].serviceId;
          const revertedServices = selectedServices.filter(id => id !== lastServiceId);
          setSelectedServices(revertedServices);
          setAddressesMarkers(prev => 
            prev.map(marker => 
              marker.serviceId === lastServiceId 
                ? { ...marker, isSelected: false }
                : marker
            )
          );
          const updatedValidMarkers = addressesMarkers
            .filter(marker => revertedServices.includes(marker.serviceId) && marker.isService)
            .sort((a, b) => {
              const indexA = revertedServices.indexOf(a.serviceId);
              const indexB = revertedServices.indexOf(b.serviceId);
              return indexA - indexB;
            });
          setArrScales(updatedValidMarkers);
          determineOriginAndDestination(updatedValidMarkers);
        } else if (showRouteSummaryPanel) {
          await generateRoute();
        }
      } else if (showRouteSummaryPanel) {
        setEstimatedTime("");
        setEstimatedDistance("");
      }
      
      setKey(prev => prev + 1);
    } else {
      setArrScales([]);
      if (selectedServiceType === RoutingServiceType.AFORO) {
        setSelectedOrigin(null);
      } else if (selectedServiceType === RoutingServiceType.DESAFORO) {
        setSelectedDestiny(null);
      }
      setRecommendedRoutes([]);
      setSelectedRouteIndex(-1);
      setEstimatedTime("");
      setEstimatedDistance("");
      setKey(prev => prev + 1);
    }
  };
  
  const handleMarkerClick = async (marker) => {
    if (marker.isService) {
      const isSelected = !marker.isSelected;
      let newSelectedServices;
      
      if (isSelected) {
        newSelectedServices = [...selectedServices, marker.serviceId];
      } else {
        newSelectedServices = selectedServices.filter(id => id !== marker.serviceId);
      }
      
      if (newSelectedServices.length > 4) {
        setErrorHeader(i18n.t("LimitReached"));
        setErrorBody(i18n.t("MaxServicesSelected"));
        setShowAlertError(true);
        return;
      }
      
      setSelectedServices(newSelectedServices);
      
      const updatedMarkers = addressesMarkers.map(m => 
        m.id === marker.id ? { ...m, isSelected } : m
      );
      
      setAddressesMarkers(updatedMarkers);
      
      if (newSelectedServices.length > 0) {
        const selectedServiceMarkers = updatedMarkers
          .filter(m => newSelectedServices.includes(m.serviceId) && m.isService)
          .sort((a, b) => {
            const indexA = newSelectedServices.indexOf(a.serviceId);
            const indexB = newSelectedServices.indexOf(b.serviceId);
            return indexA - indexB;
          });
        
        setArrScales(selectedServiceMarkers);
        determineOriginAndDestination(selectedServiceMarkers);
        
        if (newSelectedServices.length >= 2) {
          const isValid = await validateManualRouteDuration(selectedServiceMarkers);
          if (!isValid) {
            const lastServiceId = selectedServiceMarkers[selectedServiceMarkers.length - 1].serviceId;
            const revertedServices = selectedServices.filter(id => id !== lastServiceId);
            setSelectedServices(revertedServices);
            setAddressesMarkers(prev => 
              prev.map(m => 
                m.id === marker.id ? { ...m, isSelected: false } : m
              )
            );
            const updatedValidMarkers = addressesMarkers
              .filter(m => revertedServices.includes(m.serviceId) && m.isService)
              .sort((a, b) => {
                const indexA = revertedServices.indexOf(a.serviceId);
                const indexB = revertedServices.indexOf(b.serviceId);
                return indexA - indexB;
              });
            setArrScales(updatedValidMarkers);
            determineOriginAndDestination(updatedValidMarkers);
          } else if (showRouteSummaryPanel) {
            await generateRoute();
          }
        } else if (showRouteSummaryPanel) {
          setEstimatedTime("");
          setEstimatedDistance("");
        }
        
        setKey(prev => prev + 1);
      } else {
        setArrScales([]);
        if (selectedServiceType === RoutingServiceType.AFORO) {
          setSelectedOrigin(null);
        } else if (selectedServiceType === RoutingServiceType.DESAFORO) {
          setSelectedDestiny(null);
        }
        setRecommendedRoutes([]);
        setSelectedRouteIndex(-1);
        setEstimatedTime("");
        setEstimatedDistance("");
        setKey(prev => prev + 1);
      }
    }
  };

  const determineOriginAndDestination = (serviceMarkers) => {
    if (serviceMarkers.length === 0) return;

    setArrScales(serviceMarkers);

    if (selectedServiceType === RoutingServiceType.AFORO) {
        // Aforo: Base es DESTINO, primer servicio seleccionado es ORIGEN
      if (serviceMarkers.length > 0) {
        const originMarker = {
          ...serviceMarkers[0],
          typeAddress: TypeAddress.ORIGIN,
          dragg: true
        };
        setSelectedOrigin(originMarker);
        setSelectedAddressOrigin(originMarker);
        setNameTitleOrigin(
          i18n.t("TitleAddress", {
            typeAddress: i18n.t("Origin"),
            address: originMarker.description,
          })
        );
      }

    } else if (selectedServiceType === RoutingServiceType.DESAFORO) {
        // Desaforo: Base es ORIGEN, último servicio seleccionado es DESTINO
      if (serviceMarkers.length > 0) {
        const destinyMarker = {
          ...serviceMarkers[serviceMarkers.length - 1],
          typeAddress: TypeAddress.DESTINY,
          dragg: true
        };
        setSelectedDestiny(destinyMarker);
        setSelectedAddressDestiny(destinyMarker);
        setNameTitleDestiny(
          i18n.t("TitleAddress", {
            typeAddress: i18n.t("Destiny"),
            address: destinyMarker.description,
          })
        );
      }
    }
  };

  const validateManualRouteDuration = async (serviceMarkers) => {
    if (serviceMarkers.length < 2) return true;
  
    const baseAddress = addressesMarkers.find(marker => marker.isBase);
    if (!baseAddress) return true;
  
    try {
      const directionsService = new window.google.maps.DirectionsService();
      
      let origin, destination;
      
      if (selectedServiceType === RoutingServiceType.AFORO) {
        origin = serviceMarkers[0];
        destination = baseAddress;
      } else {
        origin = baseAddress;
        destination = serviceMarkers[serviceMarkers.length - 1];
      }
      
      if (!origin || !destination) return true;
  
      const waypoints = selectedServiceType === RoutingServiceType.AFORO 
        ? serviceMarkers.slice(1).map(scale => ({
            location: scale.location || scale,
            stopover: true
          }))
        : serviceMarkers.slice(0, -1).map(scale => ({
            location: scale.location || scale,
            stopover: true
          }));
  
      const request = {
        origin: origin.location || origin,
        destination: destination.location || destination,
        waypoints: waypoints,
        travelMode: window.google.maps.TravelMode.DRIVING,
        optimizeWaypoints: true,
        provideRouteAlternatives: false
      };
  
      const result = await directionsService.route(request);
      
      if (result.status === window.google.maps.DirectionsStatus.OK) {
        const route = result.routes[0];
        const totalDuration = route.legs.reduce((total, leg) => 
          total + (leg.duration ? leg.duration.value : 0), 0
        ) / 60;
  
        if (totalDuration > 120) {
          setErrorHeader(i18n.t("RouteTooLong"));
          setErrorBody(i18n.t("CurrentSelectionExceeds120Minutes", { duration: Math.round(totalDuration) }));
          setShowAlertError(true);
          setPanelError(true);
          setTimeout(() => setPanelError(false), 1000);
          return false;
        }
      }
      return true;
    } catch (error) {
      console.error("Error validating route duration:", error);
      return true;
    }
  };

  const fetchEmployeeBookings = async () => {
    try {
      const response = await getEmployeeBookings(token, {
        page: 1,
        size: 10,
        status: [ServiceStatus.FINISHED, ServiceStatus.DELETED], 
      });
      setListServices({
        page: response.page,
        size: response.size,
        pages: response.pages,
        items: response.items,
      });
      setFindServices(response.items);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching employee bookings:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isEmployee) {
      fetchEmployeeBookings();
    } else {
      const savedFilters = localStorage.getItem("historicalFilters");
      if (savedFilters) {
        const parsedFilters = JSON.parse(savedFilters);
        setFiltersOpts(parsedFilters);
        setCurrentPage(parsedFilters.data.filters.page || 1);
      }
    }
  }, [isEmployee]);

  useEffect(() => {
    if (data?.data) {
      setInfoUser(data.data);
      
      if (!data.data.is_staff) {
        searchFilters(data.data.partner_id, "company");
      }
    }
  }, [data, loading]);

  useEffect(() => {
    setFindServices(listServices.items);
  }, [listServices]);

  const searchFilters = (val, typeSearch) => {
    if (typeSearch === FilterType.TYPE) {
      setSelectedServiceType(val);
      setSearchResults([]);
      setSelectedServices([]);
      setAddressesMarkers(prev => prev.filter(marker => !marker.isService));
    }
    
    handleSearchFilters(
      val,
      typeSearch,
      filtersOpts,
      setFiltersOpts,
      setReloadList,
      setCurrentPage,
      "routingFilters",
      {
        setFCompany,
        setStatusService,
        setTypeService,
        setServiceNumber,
        setPlaceService,
        setPlateService,
      }
    );
  };

  const onGetOrgsAdmin = () => {
    let arr = [];
    getOrgsAdmin(token)
      .then((response) => {
        response.forEach((item) => {
          arr.push({ label: item.name, value: item.partner_id });
        });
        setListCompanies([...arr]);
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error.response?.data || error.message);
        setErrorAlert(true);
        setErrorAlertMessage((error?.response?.data?.detail || error.message));
      });
  };

  useEffect(() => {
    onGetOrgsAdmin();
    if (localStorage.getItem("notify") === "true") {
      setShowAlertSuccess(true);
      setTextHeader(localStorage.getItem("headerText"));
      setTextBody(localStorage.getItem("bodyText"));
      localStorage.setItem("notify", "false");
    }
  }, []);

  useEffect(() => {
    if (isLoading || findServices.length > 0) {
      setShowNoResults(false);
    }

    if (!isLoading && findServices.length === 0) {
      const timer = setTimeout(() => {
        setShowNoResults(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [isLoading, findServices]);

  const togglePanel = () => {
    setIsPanelExpanded(!isPanelExpanded);
  };

  const toggleRouteSummaryPanel = () => {
    if (showRouteSummaryPanel) {
      setIsRouteSummaryPanelOpen(prev => !prev);
    }
  };

  const getDisplayAddress = (service) => {
    const originDesc = service.origin?.address?.description || "";
    const destDesc = service.destination?.address?.description || "";
  
    const isOriginBase = isBaseAddress(originDesc);
    const isDestBase = isBaseAddress(destDesc);
  
    // Para Aforo: mostrar dirección de origen (domicilio del empleado)
    if (isDestBase && !isOriginBase) {
      return originDesc;
    }
    
    // Para Desaforo: mostrar dirección de destino (domicilio del empleado)
    if (isOriginBase && !isDestBase) {
      return destDesc;
    }
    
    // Caso por defecto: mostrar la dirección que NO es base
    if (isOriginBase) {
      return destDesc;
    }
    
    if (isDestBase) {
      return originDesc;
    }
    
    return destDesc || originDesc || i18n.t("NoAddress");
  };

  const generateRoute = async () => {
    if (selectedServices.length === 0) {
      setErrorHeader(i18n.t("NoServicesSelected"));
      setErrorBody(i18n.t("SelectAtLeastOneService"));
      setShowAlertError(true);
      return;
    }
  
    setRecommendedRoutes([]);
    setSelectedRouteIndex(-1);
  
    if (!selectedOrigin && !selectedDestiny) {
      setErrorHeader(i18n.t("MissingRoutePoints"));
      setErrorBody(i18n.t("OriginAndDestinationRequired"));
      setShowAlertError(true);
      return;
    }
  
    try {
      setIsCalculatingRoutes(true);
      
      const directionsService = new window.google.maps.DirectionsService();
      const baseAddress = addressesMarkers.find(marker => marker.isBase);
      
      if (!baseAddress) {
        setErrorHeader(i18n.t("MissingBaseAddress"));
        setErrorBody(i18n.t("BaseAddressRequired"));
        setShowAlertError(true);
        return;
      }
  
      let origin, destination, waypoints;
      
      if (selectedServiceType === RoutingServiceType.AFORO) {
            // Aforo: origen es primer servicio, destino es base
        origin = arrScales[0];
        destination = baseAddress;
        waypoints = arrScales.slice(1).map(scale => ({
          location: scale.location || scale,
          stopover: true
        }));
      } else if (selectedServiceType === RoutingServiceType.DESAFORO) {
            // Desaforo: origen es base, destino es último servicio
        origin = baseAddress;
        destination = arrScales[arrScales.length - 1];
            // Todos los servicios excepto el último son waypoints
        waypoints = arrScales.slice(0, -1).map(scale => ({
          location: scale.location || scale,
          stopover: true
        }));
      } else {
        origin = selectedOrigin;
        destination = selectedDestiny;
        waypoints = arrScales.map(scale => ({
          location: scale.location || scale,
          stopover: true
        }));
      }
  
      const request = {
        origin: origin.location || origin,
        destination: destination.location || destination,
        waypoints: waypoints,
        travelMode: window.google.maps.TravelMode.DRIVING,
        optimizeWaypoints: false,
        provideRouteAlternatives: false
      };
  
      const result = await directionsService.route(request);
      
      if (result.status === window.google.maps.DirectionsStatus.OK) {
        const route = result.routes[0];
        
        const totalDuration = route.legs.reduce((total, leg) => 
          total + (leg.duration ? leg.duration.value : 0), 0
        ) / 60;
        
        const totalDistance = route.legs.reduce((total, leg) => 
          total + (leg.distance ? leg.distance.value : 0), 0
        ) / 1000;
  
        if (totalDuration > 120) {
          setErrorHeader(i18n.t("RouteTooLong"));
          setErrorBody(i18n.t("RouteExceeds120Minutes", { duration: Math.round(totalDuration) }));
          setShowAlertError(true);
          setPanelError(true);
          setTimeout(() => setPanelError(false), 1000);
          return;
        }
  
        setEstimatedTime(`${Math.round(totalDuration)} minutos`);
        setEstimatedDistance(`${totalDistance.toFixed(1)} kilometros`);
        
        const selectedRouteData = {
          index: 0,
          directions: result,
          services: arrScales,
          waypoints: waypoints,
          origin: selectedOrigin,
          destination: selectedDestiny,
          totalDuration: Math.round(totalDuration),
          totalDistance: totalDistance.toFixed(1),
          color: routeColors[0],
          isSelected: true
        };
  
        setRecommendedRoutes([selectedRouteData]);
        setSelectedRouteIndex(0);
        
        setIsPanelExpanded(false);
        setShowRouteSummaryPanel(true);
        setIsRouteSummaryPanelOpen(true);
        
      } else {
        setErrorHeader(i18n.t("RouteCalculationError"));
        setErrorBody(i18n.t("ErrorCalculatingRoute"));
        setShowAlertError(true);
      }
    } catch (error) {
      console.error("Error calculating route:", error);
      setErrorHeader(i18n.t("RouteCalculationError"));
      setErrorBody(i18n.t("ErrorCalculatingRoute"));
      setShowAlertError(true);
    } finally {
      setIsCalculatingRoutes(false);
    }
  };

  const generateAutomaticRoutes = async (serviceMarkers) => {
    const routes = [];
    const baseAddress = addressesMarkers.find(marker => marker.isBase);
    
    if (!baseAddress) {
      console.error("No base address found");
      return routes;
    }

    const optimizedRoutes = await generateOptimizedRoutes(baseAddress, serviceMarkers);
    routes.push(...optimizedRoutes);

    if (routes.length < 3 && serviceMarkers.length > 3) {
      const sectorRoutes = await generateSectorRoutes(baseAddress, serviceMarkers, routes.length);
      routes.push(...sectorRoutes);
    }

    return filterAndRankRoutes(routes);
  };

  const generateOptimizedRoutes = async (baseAddress, serviceMarkers) => {
    const routes = [];
    const clusters = clusterServicesByProximity(serviceMarkers, 3);

    for (let i = 0; i < clusters.length; i++) {
      const cluster = clusters[i];
      
      if (cluster.length === 0) continue;

      const mainRoute = await createOptimizedRoute(baseAddress, cluster, routes.length);
      if (mainRoute && mainRoute.totalDuration <= 120) {
        routes.push(mainRoute);
      }

      if (cluster.length > 2 && routes.length < 5) {
        const variantRoutes = await generateClusterVariants(baseAddress, cluster, routes.length);
        routes.push(...variantRoutes.filter(route => route && route.totalDuration <= 120));
      }
    }

    if (clusters.length > 1 && serviceMarkers.length <= 4) {
      const globalRoute = await createOptimizedRoute(baseAddress, serviceMarkers, routes.length);
      if (globalRoute && globalRoute.totalDuration <= 120) {
        routes.push(globalRoute);
      }
    }

    return routes;
  };

  const clusterServicesByProximity = (services, maxClusters = 3) => {
    if (services.length <= 4) {
      return [services];
    }

    const clusters = [];
    const assigned = new Set();
    const densitySorted = [...services].sort((a, b) => {
      const densityA = calculateLocalDensity(a, services);
      const densityB = calculateLocalDensity(b, services);
      return densityB - densityA;
    });

    for (const service of densitySorted) {
      if (assigned.has(service.serviceId)) continue;

      const nearbyServices = findNearbyServices(service, services, assigned, 5);
      
      if (nearbyServices.length > 0) {
        clusters.push(nearbyServices);
        nearbyServices.forEach(s => assigned.add(s.serviceId));
        
        if (clusters.length >= maxClusters) break;
      }
    }

    services.forEach(service => {
      if (!assigned.has(service.serviceId)) {
        const closestCluster = findClosestCluster(service, clusters);
        if (closestCluster) {
          closestCluster.push(service);
          assigned.add(service.serviceId);
        }
      }
    });

    return clusters;
  };

  const calculateLocalDensity = (service, allServices) => {
    let count = 0;
    allServices.forEach(otherService => {
      if (service.serviceId !== otherService.serviceId) {
        const distance = calculateDistance(service.location, otherService.location);
        if (distance < 3) {
          count++;
        }
      }
    });
    return count;
  };

  const findNearbyServices = (centerService, allServices, excluded, maxDistance = 5) => {
    const nearby = [centerService];
    
    allServices.forEach(service => {
      if (service.serviceId !== centerService.serviceId && 
          !excluded.has(service.serviceId)) {
        const distance = calculateDistance(centerService.location, service.location);
        if (distance <= maxDistance) {
          nearby.push(service);
        }
      }
    });

    return nearby
      .sort((a, b) => {
        const distA = calculateDistance(centerService.location, a.location);
        const distB = calculateDistance(centerService.location, b.location);
        return distA - distB;
      })
      .slice(0, 4);
  };

  const findClosestCluster = (service, clusters) => {
    let minDistance = Infinity;
    let closestCluster = null;

    clusters.forEach(cluster => {
      const centroid = calculateClusterCentroid(cluster);
      const distance = calculateDistance(service.location, centroid);
      
      if (distance < minDistance) {
        minDistance = distance;
        closestCluster = cluster;
      }
    });

    return closestCluster;
  };

  const calculateClusterCentroid = (cluster) => {
    const sumLat = cluster.reduce((sum, service) => sum + service.location.lat, 0);
    const sumLng = cluster.reduce((sum, service) => sum + service.location.lng, 0);
    
    return {
      lat: sumLat / cluster.length,
      lng: sumLng / cluster.length
    };
  };

  const createOptimizedRoute = async (baseAddress, services, routeIndex) => {
    if (services.length === 0) return null;

    if (services.length > 4) {
      console.warn(`Attempting to create route with ${services.length} services, limiting to 4`);
      services = services.slice(0, 4);
    }
  
    try {
      const routeColor = routeColors[routeIndex % routeColors.length];
      let orderedServices = optimizeServiceOrder(baseAddress, services);
      
      if (orderedServices.length > 4) {
        orderedServices = orderedServices.slice(0, 4);
      }
      
      const directionsService = new window.google.maps.DirectionsService();
      
      let origin, destination, waypoints;
      
      if (selectedServiceType === RoutingServiceType.AFORO) {
        origin = orderedServices[0];
        destination = baseAddress;
        waypoints = orderedServices.slice(1);
      } else {
        origin = baseAddress;
        destination = orderedServices[orderedServices.length - 1];
        waypoints = orderedServices.slice(0, -1);
      }
      
      if (!origin || !destination) {
        return null;
      }
      
      const request = {
        origin: origin.location || origin,
        destination: destination.location || destination,
        waypoints: waypoints.map(wp => ({
          location: wp.location || wp,
          stopover: true
        })),
        travelMode: window.google.maps.TravelMode.DRIVING,
        optimizeWaypoints: true,
        provideRouteAlternatives: false
      };
      
      const result = await directionsService.route(request);
      
      if (result.status === window.google.maps.DirectionsStatus.OK) {
        const route = result.routes[0];
        
        const totalDuration = route.legs.reduce((total, leg) => 
          total + (leg.duration ? leg.duration.value : 0), 0
        ) / 60;
        
        const totalDistance = route.legs.reduce((total, leg) => 
          total + (leg.distance ? leg.distance.value : 0), 0
        ) / 1000;

        const totalPassengers = orderedServices.length; // Cada servicio representa un pasajero
        if (totalPassengers > 4) {
          console.error(`Route exceeds passenger limit: ${totalPassengers} > 4`);
          return null;
        }
  
        const efficiencyScore = calculateRouteEfficiency(totalDuration, totalDistance, services.length);
        const routeData = {
          index: routeIndex,
          directions: result,
          services: orderedServices,
          waypoints: waypoints,
          origin: origin,
          destination: destination,
          totalDuration: Math.round(totalDuration),
          totalDistance: totalDistance.toFixed(1),
          color: routeColor,
          isSelected: false,
          efficiencyScore: efficiencyScore,
          passengerCount: totalPassengers
        };

        return routeData;
      }
      
      return null;
    } catch (error) {
      console.error("Error creating optimized route:", error);
      return null;
    }
  };

  const optimizeServiceOrder = (baseAddress, services) => {
    if (services.length <= 1) return services;

    const unvisited = [...services];
    const ordered = [];
    
    let current = findClosestToBase(unvisited, baseAddress);
    ordered.push(current);
    removeFromArray(unvisited, current);
    
    while (unvisited.length > 0) {
      const next = findClosestService(current, unvisited);
      ordered.push(next);
      removeFromArray(unvisited, next);
      current = next;
    }
    
    return ordered;
  };

  const findClosestToBase = (services, baseAddress) => {
    return services.reduce((closest, service) => {
      const closestDist = calculateDistance(baseAddress.location, closest.location);
      const serviceDist = calculateDistance(baseAddress.location, service.location);
      return serviceDist < closestDist ? service : closest;
    });
  };

  const findClosestService = (currentService, availableServices) => {
    return availableServices.reduce((closest, service) => {
      const closestDist = calculateDistance(currentService.location, closest.location);
      const serviceDist = calculateDistance(currentService.location, service.location);
      return serviceDist < closestDist ? service : closest;
    });
  };

  const removeFromArray = (array, item) => {
    const index = array.findIndex(s => s.serviceId === item.serviceId);
    if (index !== -1) {
      array.splice(index, 1);
    }
  };

  const calculateRouteEfficiency = (duration, distance, numServices) => {
    const timeEfficiency = 120 / Math.max(duration, 1); // Penalizar tiempos largos
    const distanceEfficiency = 20 / Math.max(distance, 1); // Penalizar distancias largas
    const serviceEfficiency = numServices * 2; // Premiar más servicios
    
    return timeEfficiency + distanceEfficiency + serviceEfficiency;
  };

  const generateClusterVariants = async (baseAddress, cluster, startIndex) => {
    const variants = [];
    let currentIndex = startIndex;
    
    if (cluster.length > 2) {
      const withoutFurthest = removeFurthestService(cluster, baseAddress);
      if (withoutFurthest.length >= 2) {
        const variant = await createOptimizedRoute(baseAddress, withoutFurthest, currentIndex);
        if (variant) {
          variants.push(variant);
          currentIndex++;
        }
      }
      
      if (cluster.length > 3) {
        const closestOnly = cluster
          .sort((a, b) => {
            const distA = calculateDistance(baseAddress.location, a.location);
            const distB = calculateDistance(baseAddress.location, b.location);
            return distA - distB;
          })
          .slice(0, 3);
        
        const variant = await createOptimizedRoute(baseAddress, closestOnly, currentIndex);
        if (variant) {
          variants.push(variant);
        }
      }
    }
    
    return variants;
  };

  const removeFurthestService = (services, baseAddress) => {
    const furthest = services.reduce((furthest, service) => {
      const furthestDist = calculateDistance(baseAddress.location, furthest.location);
      const serviceDist = calculateDistance(baseAddress.location, service.location);
      return serviceDist > furthestDist ? service : furthest;
    });
    
    return services.filter(service => service.serviceId !== furthest.serviceId);
  };

  const generateSectorRoutes = async (baseAddress, serviceMarkers, startIndex) => {
    const routes = [];
    let currentIndex = startIndex;
    
    if (serviceMarkers.length < 6) return routes;
    
    const sectors = divideIntoSectors(baseAddress.location, serviceMarkers);
    
    for (const sectorServices of sectors) {
      if (sectorServices.length >= 2 && routes.length < 2) {
        const routeServices = sectorServices.slice(0, 4);
        const route = await createOptimizedRoute(baseAddress, routeServices, currentIndex);
        if (route && route.totalDuration <= 120) {

          routes.push(route);
          currentIndex++;
        }
      }
    }
    
    return routes;
  };

  const filterAndRankRoutes = (routes) => {
    const validRoutes = routes.filter(route => 
      route && route.services && route.services.length > 0
    );
    
    const uniqueRoutes = removeDuplicateRoutes(validRoutes);
    
    const rankedRoutes = uniqueRoutes.sort((a, b) => {
      const scoreA = a.efficiencyScore || 0;
      const scoreB = b.efficiencyScore || 0;
      return scoreB - scoreA;
    });
    
    const bestRoutes = rankedRoutes.slice(0, 3);
    
    return bestRoutes;
  };

  const calculateRecommendedRoutes = async () => {
    if (!selectedOriginAddress || !selectedServiceType) {
      setErrorHeader(i18n.t("MissingConfiguration"));
      setErrorBody(i18n.t("SelectAddressAndType"));
      setShowAlertError(true);
      return;
    }
  
    if (searchResults.length === 0) {
      setErrorHeader(i18n.t("NoServicesAvailable"));
      setErrorBody(i18n.t("NoServicesForRouting"));
      setShowAlertError(true);
      return;
    }
  
    setIsCalculatingRoutes(true);
  
    try {
      const availableServiceMarkers = addressesMarkers.filter(
        marker => marker.isService && !marker.isBase
      );
  
      console.log("Buscando rutas optimizadas para:", availableServiceMarkers.length, "servicios");
  
      if (availableServiceMarkers.length === 0) {
        setErrorHeader(i18n.t("NoServiceMarkers"));
        setErrorBody(i18n.t("NoMarkersForRouting"));
        setShowAlertError(true);
        return;
      }
  
      const routes = await generateAutomaticRoutes(availableServiceMarkers);
  
      const validRoutes = routes.filter(route => 
        route && 
        route.services && 
        route.services.length > 0 &&
        route.services.length <= 4
      );
      
      console.log("Rutas óptimas generadas:", routes.length);
      
      setSelectedRouteIndex(-1);
      
      const routesWithSelection = validRoutes.map((route, index) => ({
        ...route,
        isSelected: false,
        index: index
      }));
      
      setAllOriginalRoutes(routesWithSelection);
      setRecommendedRoutes(routesWithSelection);
      
      if (validRoutes.length > 0) {
        setShowAlertSuccess(true);
        setTextHeader(i18n.t("RoutesGenerated"));
        setTextBody(i18n.t("BestRoutesSelected", { 
          count: validRoutes.length,
          total: availableServiceMarkers.length 
        }));
      } else {
        setErrorHeader(i18n.t("NoRoutesFound"));
        setErrorBody(i18n.t("NoValidRoutesFound"));
        setShowAlertError(true);
      }
    } catch (error) {
      console.error("Error calculating routes:", error);
      setErrorHeader(i18n.t("RouteCalculationError"));
      setErrorBody(i18n.t("ErrorCalculatingRoutes"));
      setShowAlertError(true);
    } finally {
      setIsCalculatingRoutes(false);
    }
  };
  
  const divideIntoSectors = (center, services) => {
    const sectors = [[], [], [], []]; // N, S, E, O
    
    services.forEach(service => {
      const latDiff = service.location.lat - center.lat;
      const lngDiff = service.location.lng - center.lng;
      
      if (Math.abs(latDiff) > Math.abs(lngDiff)) {
        sectors[latDiff > 0 ? 0 : 1].push(service);
      } else {
        sectors[lngDiff > 0 ? 2 : 3].push(service);
      }
    });
    
    return sectors.filter(sector => sector.length > 0);
  };

  const calculateDistance = (point1, point2) => {
    const R = 6371; // Radio de la Tierra en km
    const dLat = (point2.lat - point1.lat) * Math.PI / 180;
    const dLon = (point2.lng - point1.lng) * Math.PI / 180;
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(point1.lat * Math.PI / 180) * Math.cos(point2.lat * Math.PI / 180) * 
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
  };
  
  const removeDuplicateRoutes = (routes) => {
    const uniqueRoutes = [];
    const routeHashes = new Set();
    
    routes.forEach(route => {
      if (route && route.services) {
        const hash = route.services.map(s => s.serviceId).sort().join('-');
        if (!routeHashes.has(hash)) {
          routeHashes.add(hash);
          uniqueRoutes.push(route);
        }
      }
    });
    
    return uniqueRoutes;
  };
  
  const handleRouteClick = async (index) => {
    const updatedRoutes = recommendedRoutes.map((route, i) => ({
      ...route,
      isSelected: i === index
    }));
    
    setSelectedRouteIndex(index);
    setRecommendedRoutes(updatedRoutes);
  
    const selectedRoute = recommendedRoutes[index];
    
    if (selectedRoute) {
      setEstimatedTime(`${selectedRoute.totalDuration} minutos`);
      setEstimatedDistance(`${selectedRoute.totalDistance} kilometros`);
      
      const serviceIds = selectedRoute.services.map(service => service.serviceId);
      setSelectedServices(serviceIds);
      
      setAddressesMarkers(prev => {
        const baseMarker = prev.find(marker => marker.isBase);
        const orderedServiceMarkers = selectedRoute.services.map(serviceMarker => ({
          ...serviceMarker,
          isSelected: true
        }));
        
        return baseMarker 
          ? [baseMarker, ...orderedServiceMarkers]
          : orderedServiceMarkers;
      });

      setArrScales(selectedRoute.services);
      determineOriginAndDestination(selectedRoute.services);
      
      await validateManualRouteDuration(selectedRoute.services);
      
      setKey(prev => prev + 1);
    }
  };

  const useSelectedRoute = async () => {
    if (selectedRouteIndex === -1) {
      setErrorHeader(i18n.t("NoRouteSelected"));
      setErrorBody(i18n.t("PleaseSelectRouteFromMap"));
      setShowAlertError(true);
      return;
    }
    
    const selectedRoute = recommendedRoutes[selectedRouteIndex];
    const baseAddress = addressesMarkers.find(marker => marker.isBase);
    
    if (selectedServiceType === RoutingServiceType.AFORO) {
      setSelectedOrigin(selectedRoute.origin);
      setSelectedDestiny(baseAddress);
    } else {
      setSelectedOrigin(baseAddress);
      setSelectedDestiny(selectedRoute.destination);
    }
    
    setEstimatedTime(`${selectedRoute.totalDuration} minutos`);
    setEstimatedDistance(`${selectedRoute.totalDistance} kilometros`);
  
    const selectedServiceIds = selectedRoute.services.map(service => service.serviceId);
    const baseMarker = addressesMarkers.find(marker => marker.isBase);
    const orderedServiceMarkers = selectedRoute.services.map(serviceMarker => ({
      ...serviceMarker,
      isSelected: true
    }));
    
    const orderedMarkers = baseMarker 
      ? [baseMarker, ...orderedServiceMarkers]
      : orderedServiceMarkers;
    
    setAddressesMarkers(orderedMarkers);
    setSelectedServices(selectedServiceIds);
    setArrScales(selectedRoute.services);
    
    const singleRouteArray = [{
      ...selectedRoute,
      isSelected: true,
      index: 0
    }];
    
    setRecommendedRoutes(singleRouteArray);
    setSelectedRouteIndex(0);
    
    setIsPanelExpanded(false);
    setShowRouteSummaryPanel(true);
    setIsRouteSummaryPanelOpen(true);
    
    await validateManualRouteDuration(selectedRoute.services);
    
    setShowAlertSuccess(true);
    setTextHeader(i18n.t("RouteSelected"));
    setTextBody(i18n.t("RouteSelectedSuccessfully"));
    setKey(prev => prev + 1);
  };

  const cleanMapAfterConfirmation = () => {
    setSelectedServices([]);
    setSelectedRouteIndex(-1);
    setRecommendedRoutes([]);
    setAllOriginalRoutes([]);
    setEstimatedTime("");
    setEstimatedDistance("");
    
    const baseAddress = addressesMarkers.find(marker => marker.isBase);
    if (baseAddress) {
      setAddressesMarkers([baseAddress]);
      setSelectedOrigin(baseAddress);
      setSelectedAddressOrigin(baseAddress);
      setNameTitleOrigin(
        i18n.t("TitleAddress", {
          typeAddress: i18n.t("Origin"),
          address: baseAddress.description,
        })
      );
    } else {
      setAddressesMarkers([]);
      setSelectedOrigin(null);
      setSelectedAddressOrigin({});
    }
    
    setSelectedDestiny(null);
    setSelectedAddressDestiny({});
    setArrScales([]);
    setShowRouteSummaryPanel(false);
    setIsRouteSummaryPanelOpen(false);
    setIsPanelExpanded(true);

    isSubmittingRef.current = false;
    setIsSubmitting(false);
  };

  const confirmRoute = async () => {
    if (isSubmittingRef.current) return;
    
    isSubmittingRef.current = true;
    setIsSubmitting(true);
  
    try {
      if (selectedServices.length === 0) {
        setErrorHeader(i18n.t("NoServicesSelected"));
        setErrorBody(i18n.t("SelectAtLeastOneService"));
        setShowAlertError(true);
        isSubmittingRef.current = false;
        setIsSubmitting(false);
        return;
      }
  
      const selectedServicesData = searchResults.filter(service => 
        selectedServices.includes(service.id)
      );
  
      if (selectedServicesData.length === 0) {
        setErrorHeader(i18n.t("InvalidServices"));
        setErrorBody(i18n.t("SelectedServicesNotFound"));
        setShowAlertError(true);
        isSubmittingRef.current = false;
        setIsSubmitting(false);
        return;
      }
  
      const baseAddress = addressesMarkers.find(marker => marker.isBase);
      if (!baseAddress) {
        setErrorHeader(i18n.t("MissingBaseAddress"));
        setErrorBody(i18n.t("BaseAddressRequired"));
        setShowAlertError(true);
        isSubmittingRef.current = false;
        setIsSubmitting(false);
        return;
      }
  
      if (selectedRouteIndex !== -1 && recommendedRoutes[selectedRouteIndex]) {
        const selectedRoute = recommendedRoutes[selectedRouteIndex];
        if (selectedServiceType === RoutingServiceType.AFORO) {
          setSelectedOrigin(selectedRoute.origin);
          setSelectedDestiny(baseAddress);
        } else {
          setSelectedOrigin(baseAddress);
          setSelectedDestiny(selectedRoute.destination);
        }
      }
  
      if (!selectedOrigin || !selectedDestiny) {
        setErrorHeader(i18n.t("MissingRoutePoints"));
        setErrorBody(i18n.t("OriginAndDestinationRequired"));
        setShowAlertError(true);
        isSubmittingRef.current = false;
        setIsSubmitting(false);
        return;
      }
  
      const payload = await buildRoutingPayload(selectedServicesData);
      const response = await postServicesAdmin(token, payload);
  
      if (response && response.code) {
        setShowAlertSuccess(true);
        setTextHeader(i18n.t("RouteGeneratedSuccessfully"));
        setTextBody(i18n.t("RouteCreatedWithCode", { code: response.code }));
        
        setShowRouteSummaryPanel(false);
        setIsRouteSummaryPanelOpen(false);
        
        localStorage.setItem("notify", "true");
        localStorage.setItem("headerText", i18n.t("RouteCreated"));
        localStorage.setItem(
          "bodyText",
          i18n.t("RouteCreatedWithCode", {
            code: `<a href="/services/request/${response.code}">${response.code}</a>`,
          })
        );
  
        setTimeout(() => {
          handleSearch(1);
          cleanMapAfterConfirmation();
        }, 1500);
  
      } else {
        throw new Error("Respuesta inválida del servidor");
      }
  
    } catch (error) {
      console.error("Error al confirmar la ruta:", error);
      setErrorHeader(i18n.t("RouteCreationError"));
      setErrorBody(error?.response?.data?.detail || error.message || i18n.t("UnknownError"));
      setShowAlertError(true);
    } finally {
      
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  };

  const buildRoutingPayload = async (services) => {
    let orderedServices = Array.isArray(services) ? [...services] : [];
  
    if (
        selectedRouteIndex !== -1 &&
        recommendedRoutes[selectedRouteIndex]?.services?.length
    ) {
        const selectedRoute = recommendedRoutes[selectedRouteIndex];
        orderedServices = selectedRoute.services
            .map(m => services.find(s => s.id === m.serviceId))
            .filter(s => s && s.id);
    } else {
        orderedServices = arrScales
            .map(marker => services.find(s => s.id === marker.serviceId))
            .filter(s => s && s.id);
    }
  
    if (!orderedServices.length) {
        throw new Error("No services available to build routing payload");
    }
  
    const baseAddress = addressesMarkers.find(m => m.isBase);
    
    if (!baseAddress) {
        throw new Error("Base address not found");
    }
  
    const riders = orderedServices.map((service, index) => {
        const isLastService = index === orderedServices.length - 1;
        const isFirstService = index === 0;
        
        let dropoffConfig;
        
        if (selectedServiceType === RoutingServiceType.AFORO) {
            // En Aforo: todos van al destino (base), excepto escalas intermedias
            dropoffConfig = {
                destination: isLastService,
                scale_order: isLastService ? 0 : index + 1
            };
        } else if (selectedServiceType === RoutingServiceType.DESAFORO) {
            // En Desaforo: todos van al destino (última parada)
            dropoffConfig = {
                destination: isLastService,
                scale_order: isLastService ? 0 : index + 1
            };
        } else {
            dropoffConfig = {
                destination: isLastService,
                scale_order: isLastService ? 0 : index + 1
            };
        }
        
        return {
            id: service.riders_id || service.riders?.[0]?.id || service.id,
            name: service.riders_name || service.riders?.[0]?.name || i18n.t("UnknownEmployee"),
            cost_center_id: service.cost_center_id || "",
            cost_center_name: service.cost_center_name || "N/A",
            dropoff: dropoffConfig
        };
    });
  
    const scales = [];
    
    if (selectedServiceType === RoutingServiceType.AFORO) {
        // En Aforo: todos los servicios excepto el primero (origen) son escalas
        for (let i = 1; i < orderedServices.length; i++) {
            const service = orderedServices[i];
            const marker = addressesMarkers.find(m => m.serviceId === service.id);
            scales.push({
                order: i,
                pre_request_uuid: service.id,
                address: {
                    description: getDisplayAddress(service),
                    latlng: {
                        latitude: marker?.location?.lat ?? service.origin?.address?.latlng?.latitude ?? 19.432608,
                        longitude: marker?.location?.lng ?? service.origin?.address?.latlng?.longitude ?? -99.133209
                    }
                }
            });
        }
    } else if (selectedServiceType === RoutingServiceType.DESAFORO) {
        // En Desaforo: todos los servicios excepto el último (destino) son escalas
        for (let i = 0; i < orderedServices.length - 1; i++) {
            const service = orderedServices[i];
            const marker = addressesMarkers.find(m => m.serviceId === service.id);
            scales.push({
                order: i + 1,
                pre_request_uuid: service.id,
                address: {
                    description: getDisplayAddress(service),
                    latlng: {
                        latitude: marker?.location?.lat ?? service.origin?.address?.latlng?.latitude ?? 19.432608,
                        longitude: marker?.location?.lng ?? service.origin?.address?.latlng?.longitude ?? -99.133209
                    }
                }
            });
        }
    }
  
    let origin;
    let destination;
  
    if (selectedServiceType === RoutingServiceType.AFORO) {
        const firstService = orderedServices[0];
        const firstMarker = addressesMarkers.find(m => m.serviceId === firstService.id);
        
        origin = {
            address: {
                description: getDisplayAddress(firstService),
                latlng: {
                    latitude: firstMarker?.location?.lat ?? 19.432608,
                    longitude: firstMarker?.location?.lng ?? -99.133209
                }
            }
        };
  
        destination = {
            address: {
                description: selectedOriginAddress
                    ? getFullBaseAddress(selectedOriginAddress)
                    : BASE_ADDRESSES_FULL[0],
                latlng: {
                    latitude: baseAddress.location.lat,
                    longitude: baseAddress.location.lng
                }
            }
        };
    } else if (selectedServiceType === RoutingServiceType.DESAFORO) {
        const lastService = orderedServices[orderedServices.length - 1];
        const lastMarker = addressesMarkers.find(m => m.serviceId === lastService.id);
        
        origin = {
            address: {
                description: selectedOriginAddress
                    ? getFullBaseAddress(selectedOriginAddress)
                    : BASE_ADDRESSES_FULL[0],
                latlng: {
                    latitude: baseAddress.location.lat,
                    longitude: baseAddress.location.lng
                }
            }
        };
  
        destination = {
            pre_request_uuid: lastService.id,
            address: {
                description: getDisplayAddress(lastService),
                latlng: {
                    latitude: lastMarker?.location?.lat ?? 19.432608,
                    longitude: lastMarker?.location?.lng ?? -99.133209
                }
            }
        };
    } else {
        const firstService = orderedServices[0];
        const lastService = orderedServices[orderedServices.length - 1];
        const firstMarker = addressesMarkers.find(m => m.serviceId === firstService.id);
        const lastMarker = addressesMarkers.find(m => m.serviceId === lastService.id);
        
        origin = {
            address: {
                description: getDisplayAddress(firstService),
                latlng: {
                    latitude: firstMarker?.location?.lat ?? 19.432608,
                    longitude: firstMarker?.location?.lng ?? -99.133209
                }
            }
        };
  
        destination = {
            pre_request_uuid: lastService.id,
            address: {
                description: getDisplayAddress(lastService),
                latlng: {
                    latitude: lastMarker?.location?.lat ?? 19.432608,
                    longitude: lastMarker?.location?.lng ?? -99.133209
                }
            }
        };
    }
  
    return {
        company_id: "6823",
        scheduled_start: {
            timezone: "America/Mexico_City",
            date: dateService,
            time: hourService
        },
        info: {
            requested_by: {
                id: userProfile.sub,
                name: userProfile.username
            },
            action_by: {
                id: userProfile.sub,
                name: userProfile.username
            },
            riders,
            unit_number: 1,
            scales,
            origin,
            destination
        },
        type: "CLOSED"
    };
}; 

const cancelRoute = () => {
  if (allOriginalRoutes.length > 0) {
    setRecommendedRoutes(allOriginalRoutes.map((route, index) => ({
      ...route,
      isSelected: false,
      index: index
    })));
    
    setSelectedRouteIndex(-1);
    restoreAllMarkers();
    setShowAlertSuccess(true);
    setTextHeader(i18n.t("RouteCancelled"));
    setTextBody(i18n.t("AllRoutesRestored"));
  }
  
  setShowRouteSummaryPanel(false);
  setIsRouteSummaryPanelOpen(false);
  setIsPanelExpanded(true);
};

  const paginatedServices = searchResults.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  
  const totalPagesFront = Math.ceil(searchResults.length / pageSize);  

  const restoreAllMarkers = () => {
    const serviceMarkers = [];
    const createAllMarkers = async () => {
      for (const service of searchResults) {
        const address = getDisplayAddress(service);
        
        if (address && !isBaseAddress(address)) {
          const geocodedAddress = await geocodeAddress(address);
          if (geocodedAddress) {
            const serviceType = getServiceType(service);
            
            serviceMarkers.push({
              id: `service-${service.id}`,
              location: geocodedAddress,
              description: address,
              typeAddress: TypeAddress.ARRAY_SCALES,
              dragg: true,
              isService: true,
              serviceId: service.id,
              serviceData: service,
              serviceType: serviceType,
              isSelected: false
            });
          }
        }
      }
      
      const baseAddress = addressesMarkers.find(marker => marker.isBase);
      const allMarkers = baseAddress ? [baseAddress, ...serviceMarkers] : serviceMarkers;
      
      setAddressesMarkers(allMarkers);
      setSelectedServices([]);
      setArrScales([]);
      setEstimatedTime("");
      setEstimatedDistance("");
      
      if (selectedServiceType === RoutingServiceType.AFORO) {
        setSelectedOrigin(null);
        setSelectedDestiny(baseAddress || null);
      } else if (selectedServiceType === RoutingServiceType.DESAFORO) {
        setSelectedOrigin(baseAddress || null);
        setSelectedDestiny(null);
      } else {
        setSelectedOrigin(null);
        setSelectedDestiny(null);
      }
    };
    
    createAllMarkers();
  };

  const getOrderedServicesForSummary = () => {
    if (selectedRouteIndex !== -1 && recommendedRoutes[selectedRouteIndex]?.services) {
      const selectedRoute = recommendedRoutes[selectedRouteIndex];
      return selectedRoute.services
        .map(serviceMarker => {
          return searchResults.find(s => s.id === serviceMarker.serviceId);
        })
        .filter(s => s && s.id);
    }
    
    if (arrScales.length > 0) {
      return arrScales
        .map(serviceMarker => {
          return searchResults.find(s => s.id === serviceMarker.serviceId);
        })
        .filter(s => s && s.id);
    }
    
    return searchResults
      .filter(service => selectedServices.includes(service.id));
  };

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadcrumbLink
            title={i18n.t("Routing")}
            link='/services/routing'
            breadcrumbItem={i18n.t("ControlTower")}
          />
          <Row>
            <Col xxl={12} md={12} xs={12} className="routing-map-container">
              <div className={`routing-control-panel ${panelError ? 'panel-error' : ''}`}>
                <div className="panel-header" onClick={togglePanel}>
                  <span className="panel-title">{i18n.t("SummaryOfRequest")}</span>
                  <i 
                    className={`fa ${isPanelExpanded ? 'fa-angle-up' : 'fa-angle-down'} route-panel-icon`}
                  />
                </div>                
                {isPanelExpanded && (
                  <>
                    <div className="panel-content">
                      <div className="orange-separator" />
                      <div className="panel-section d-flex align-items-center gap-3 flex-wrap">
                        <div className="form-group mb-0">
                          <Select
                            name="originAddress"
                            placeholder={i18n.t("Address")}
                            options={originAddressOptions}
                            isClearable
                            className="select2-selection select-origin-address"
                            value={originAddressOptions.find((item) => item.value === selectedOriginAddress) || null}
                            onChange={(e) => setSelectedOriginAddress(e?.value || "Norte 45 847")}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                              container: (base) => ({
                                ...base,
                                width: "200px",
                              }),
                              control: (base) => ({
                                ...base,
                                height: "38px",
                                paddingRight: "35px",
                                borderRadius: "0.25rem",
                                borderColor: "#CED4DA",
                                boxShadow: "none",
                                backgroundColor: "#FFFFFF",
                                "&:hover": { borderColor: "#CED4DA" },
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                              menu: (base) => ({
                                ...base,
                                backgroundColor: "#FFFFFF",
                                zIndex: 9999,
                              }),
                              menuList: (base) => ({
                                ...base,
                                backgroundColor: "#FFFFFF",
                                maxHeight: "200px",
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                display: "none",
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                paddingLeft: "8px",
                              }),
                            }}
                          />
                        </div>
                        <div className="form-group mb-0">
                          <Select
                            name="type"
                            placeholder={i18n.t("Type")}
                            options={listRouteType()}
                            isClearable
                            className="select2-selection select-type"
                            value={listRouteType().find(item => item.value === typeService) || null}
                            onChange={(e) => {
                              setTypeService(e?.value || null);
                              searchFilters(e?.value || null, FilterType.TYPE);
                            }}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                              container: (base) => ({
                                ...base,
                                width: "140px",
                              }),
                              control: (base) => ({
                                ...base,
                                height: "38px",
                                paddingRight: "35px",
                                borderRadius: "0.25rem",
                                borderColor: "#CED4DA",
                                boxShadow: "none",
                                backgroundColor: "#FFFFFF",
                                "&:hover": { borderColor: "#CED4DA" },
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                              menu: (base) => ({
                                ...base,
                                backgroundColor: "#FFFFFF",
                                zIndex: 9999,
                              }),
                              menuList: (base) => ({
                                ...base,
                                backgroundColor: "#FFFFFF",
                                maxHeight: "200px",
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                display: "none",
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                paddingLeft: "8px",
                              }),
                            }}
                          />
                        </div>
                        <div className="form-group mb-0">
                          <Flatpickr
                            className="form-control d-block"
                            placeholder={i18n.t("Date")}
                            options={{
                              minDate: "today",
                              altInput: true,
                              altFormat: "d/m/Y",
                              dateFormat: "Y-m-d",
                            }}
                            value={dateService}
                            onChange={(e) => onChangeDate(e)}
                            style={{ width: "160px" }}
                          />
                          <i className="mdi mdi-calendar-outline input-icon" />
                        </div>
                        <div className="form-group mb-0">
                          <div className="custom-input">
                            <Select
                              name="hour"
                              placeholder={i18n.t("Hour")}
                              options={allowedHoursOptions}
                              isClearable
                              className="select2-selection hour-select"
                              classNamePrefix="hour-select"
                              value={allowedHoursOptions.find((item) => item.value === hourService) || null}
                              onChange={(e) => {
                                const selected = e?.value || "";
                                setHourService(selected);
                                if (selected) {
                                  searchFilters(selected, FilterType.HOUR);
                                }
                              }}
                              menuPortalTarget={document.body}
                              styles={{
                                container: (base) => ({
                                  ...base,
                                  width: "140px",
                                }),
                                control: (base) => ({
                                  ...base,
                                  height: "38px",
                                  paddingRight: "35px",
                                  borderRadius: "0.25rem",
                                  borderColor: "#CED4DA",
                                  boxShadow: "none",
                                  backgroundColor: "#FFFFFF",
                                  "&:hover": { borderColor: "#CED4DA" },
                                }),
                                menu: (base) => ({
                                  ...base,
                                  backgroundColor: "#FFFFFF",
                                  zIndex: 9999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                menuList: (base) => ({
                                  ...base,
                                  backgroundColor: "#FFFFFF",
                                  maxHeight: "200px",
                                }),
                                indicatorsContainer: (base) => ({
                                  ...base,
                                  display: "none",
                                }),
                                valueContainer: (base) => ({
                                  ...base,
                                  paddingLeft: "8px",
                                }),
                              }}      
                            />
                            <i className="mdi mdi-clock-outline input-icon" style={{ color: "#FF5F00" }} />
                          </div>
                        </div>
                        <button
                          type="button"
                          className="btn btn-users d-flex align-items-center gap-2"
                          onClick={() => handleSearch(1)}
                          disabled={isSearching || !hourService}
                        >
                          {isSearching ? (
                            <>
                              <Spinners size="sm" />
                              {i18n.t("Searching")}
                            </>
                          ) : (
                            i18n.t("Search")
                          )}
                        </button>
                      </div>
                      {searchError && (
                        <div className="alert alert-danger mt-2" role="alert">
                          <i className="fa fa-exclamation-circle me-2" />
                          {searchError}
                        </div>
                      )}
                      <div className="orange-separator" />
                      {hasSearched && (
                        <div className="table-container">
                          {isSearching ? (
                            <div className="text-center py-4">
                              <Spinners />
                              <p className="mt-2">{i18n.t("LoadingResults")}</p>
                            </div>
                          ) : searchResults.length > 0 ? (
                            <>
                              <Table className="table table-bordered mb-0 table-request-services">
                                <thead>
                                  <tr>
                                    <th></th>
                                    <th>{i18n.t("Type")}</th>
                                    <th>{i18n.t("Employee")}</th>
                                    <th>{i18n.t("Address")}</th>
                                    <th>{i18n.t("Date")}</th>
                                    <th>{i18n.t("Hour")}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {paginatedServices.map((service, index) => {
                                    const fullAddress = getDisplayAddress(service);
                                    const truncatedAddress = truncateText(fullAddress, 30);
                                    const addressId = `address-tooltip-${index}`;
                                    const isSelected = selectedServices.includes(service.id);
                                    const selectionOrder = selectedServices.indexOf(service.id) + 1;
                                    
                                    return (
                                      <tr key={service.id || index} className={isSelected ? 'table-selected' : ''}>
                                        <td>
                                          <div className="selection-checkbox-container">
                                            <input
                                              type="checkbox"
                                              className="route-checkbox"
                                              checked={isSelected}
                                              onChange={() => toggleSelectService(service.id)}
                                              id={`service-${service.id}`}
                                            />
                                            {isSelected && (
                                              <span 
                                                className="selection-order-badge"
                                                style={{
                                                  position: 'absolute',
                                                  top: '-8px',
                                                  right: '-8px',
                                                  width: '20px',
                                                  height: '20px',
                                                  borderRadius: '50%',
                                                  backgroundColor: '#FF5F00',
                                                  color: 'white',
                                                  fontSize: '11px',
                                                  fontWeight: 'bold',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  border: '2px solid white'
                                                }}
                                              >
                                                {selectionOrder}
                                              </span>
                                            )}
                                          </div>
                                        </td>
                                        <td>{getServiceType(service)}</td>
                                        <td>{service.riders_name || i18n.t("NoEmployeeName")}</td>
                                        <td className="address-cell">
                                          <span 
                                            id={addressId}
                                            style={{ cursor: fullAddress.length > 50 ? 'help' : 'default' }}
                                          >
                                            {truncatedAddress}
                                          </span>
                                          {fullAddress.length > 50 && (
                                            <Tooltip
                                              placement="top"
                                              isOpen={tooltipOpen[index] || false}
                                              target={addressId}
                                              toggle={() => toggleTooltip(index)}
                                            >
                                              {fullAddress}
                                            </Tooltip>
                                          )}
                                        </td>
                                        <td>
                                          {service.scheduled_start?.date 
                                            ? formatDate(service.scheduled_start.date)
                                            : 'N/A'
                                          }
                                        </td>
                                        <td>
                                          {service.scheduled_start?.time 
                                            ? formatTime(service.scheduled_start.time)
                                            : 'N/A'
                                          }
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                              <PaginationV2
                                currentPage={currentPage}
                                pageSize={pageSize}
                                totalItems={totalItems}
                                onChangePage={handlePageChange}
                                isLoading={isSearching}
                              />
                              <div className="orange-separator" />
                              <div className="d-flex align-items-center">
                                <button
                                  className="btn btn-users"
                                  onClick={generateRoute}
                                  disabled={selectedServices.length === 0}
                                  style={{
                                    opacity: selectedServices.length === 0 ? 0.5 : 1,
                                    cursor: selectedServices.length === 0 ? "not-allowed" : "pointer",
                                  }}
                                >
                                  {i18n.t("GenerateRoute")}
                                </button>
                                <button
                                  type="button"
                                  className="btn-route-recommendations"
                                  onClick={calculateRecommendedRoutes}
                                  disabled={searchResults.length === 0 || isCalculatingRoutes || !selectedOriginAddress}
                                  style={{
                                    opacity: (searchResults.length === 0 || !selectedOriginAddress) ? 0.5 : 1,
                                    cursor: (searchResults.length === 0 || !selectedOriginAddress) ? "not-allowed" : "pointer",
                                  }}
                                >
                                  {isCalculatingRoutes ? (
                                    <>
                                      <Spinners size="sm" />
                                      {i18n.t("CalculatingRoutes")}
                                    </>
                                  ) : (
                                    i18n.t("ViewRouteRecommendations")
                                  )}
                                </button>
                              </div>
                              {recommendedRoutes.length > 0 && (
                                <div className="recommended-routes-panel mt-3 p-3 bg-light rounded">
                                  <h6 className="mb-2">
                                    <i className="fa fa-route me-2" />
                                    {i18n.t("RecommendedRoutes")} ({recommendedRoutes.length})
                                  </h6>                                 
                                  <p className="text-muted small mb-3">
                                    {i18n.t("ClickOnMapRoute")}
                                  </p>                             
                                  <div className="routes-info-grid">
                                    {recommendedRoutes.map((route, index) => (
                                      <div 
                                        key={index}
                                        className={`route-info-card ${route.isSelected ? 'route-info-card-selected' : ''} p-2 mb-2`}
                                        style={{
                                          borderLeft: `3px solid ${route.color}`,
                                          cursor: 'pointer',
                                          backgroundColor: route.isSelected ? '#e3f2fd' : 'white',
                                          transition: 'background-color 0.3s'
                                        }}
                                        onClick={() => handleRouteClick(index)}
                                      >
                                        <div className="d-flex justify-content-between align-items-center">
                                          <div>
                                            <strong style={{ color: route.color }}>
                                              {i18n.t("Route")} {index + 1}
                                            </strong>
                                            <div className="small text-muted">
                                              {i18n.t("Stops")}: {route.services.length} | {i18n.t("Duration")}: {route.totalDuration} min | {i18n.t("Distance")}: {route.totalDistance} km
                                            </div>
                                          </div>
                                          {route.isSelected && (
                                            <i className="fa fa-check-circle text-success" />
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </div>                           
                                  {selectedRouteIndex !== -1 && (
                                    <div className="mt-3">
                                      <button
                                        className="btn btn-users"
                                        onClick={useSelectedRoute}
                                      >
                                        {i18n.t("UseThisRoute")}
                                      </button>
                                    </div>
                                  )}
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="text-center py-4">
                              <img 
                                src={folderNoResults} 
                                alt="No results" 
                                className="mb-3"
                                style={{ width: '80px', opacity: 0.5 }}
                              />
                              <p className="text-muted">{i18n.t("NoResultsFound")}</p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
              {showRouteSummaryPanel && (
                <div className="routing-summary-panel">
                  <div className="panel-header" onClick={toggleRouteSummaryPanel} style={{ cursor: "pointer" }}>
                    <span className="panel-title">{i18n.t("RouteSummary")}</span>
                    <i
                      className={`fa ${isRouteSummaryPanelOpen ? "fa-angle-up" : "fa-angle-down"} route-panel-icon`}
                    />
                  </div>
                  {isRouteSummaryPanelOpen && (
                    <div className="panel-content">
                      <div className="orange-separator" />
                      <div className="summary-section">
                        <div className="table-container summary-table">
                          <Table className="table table-bordered mb-0 table-request-services">
                            <thead>
                              <tr>
                                <th>{i18n.t("Order")}</th>
                                <th>{i18n.t("Employee")}</th>
                                <th>{i18n.t("Address")}</th>
                                <th>{i18n.t("Date")}</th>
                                <th>{i18n.t("Hour")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {getOrderedServicesForSummary().map((service, index) => {
                                const fullAddress = getDisplayAddress(service);
                                const truncatedAddress = truncateText(fullAddress, 25);
                                const stopNumber = index + 1;
                                const isLastStop = index === getOrderedServicesForSummary().length - 1;

                                let stopType = i18n.t("Scale");
                                if (selectedServiceType === RoutingServiceType.AFORO && index === 0) {
                                  stopType = i18n.t("Origin");
                                } else if (selectedServiceType === RoutingServiceType.DESAFORO && isLastStop) {
                                  stopType = i18n.t("Destiny");
                                } else {
                                  stopType = `${i18n.t("Scale")} ${stopNumber}`;
                                }
                                
                                return (
                                  <tr key={`summary-${service.id}`}>
                                    <td>
                                      <div>
                                        <span
                                          className="badge stop-badge"
                                          style={{
                                            backgroundColor:
                                              index === 0 && selectedServiceType === RoutingServiceType.AFORO
                                                ? "#FF5F00"
                                                : isLastStop && selectedServiceType === RoutingServiceType.DESAFORO
                                                ? "#FF5F00"
                                                : "#6C757D"
                                          }}
                                        >
                                          {stopType}
                                        </span>
                                      </div>
                                    </td>
                                    <td>{service.riders_name || i18n.t("NoEmployeeName")}</td>
                                    <td className="address-cell">
                                      <span title={fullAddress}>
                                        {truncatedAddress}
                                      </span>
                                    </td>
                                    <td>
                                      {service.scheduled_start?.date 
                                        ? formatDate(service.scheduled_start.date)
                                        : 'N/A'
                                      }
                                    </td>
                                    <td>
                                      {service.scheduled_start?.time 
                                        ? formatTime(service.scheduled_start.time)
                                        : 'N/A'
                                      }
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                      <div className="orange-separator" />
                      <div className="route-info-section">
                        <div className="route-info-item">
                          <span className="info-label">{i18n.t("EstimatedTime")}:</span>
                          <p className="info-value">{estimatedTime}</p>
                        </div>
                        <div className="route-info-item">
                          <span className="info-label">{i18n.t("EstimatedDistance")}:</span>
                          <p className="info-value">{estimatedDistance}</p>
                        </div>
                      </div>
                      <div className="orange-separator" />
                      <div className="action-buttons d-flex gap-3">
                        <button
                          className="btn btn-confirm"
                          onClick={confirmRoute}
                          disabled={isSubmitting}
                        >
                          {i18n.t("Confirm")}
                        </button>
                        <button
                          className="btn btn-cancel border"
                          onClick={cancelRoute}
                        >
                          {i18n.t("Cancel")}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
              <RoutingMap
                key={key}
                titleAdressArrScales={titleAdressArrScales}
                titleAdressArrEmployees={titleAdressArrEmployees}
                setNameTitleDestiny={setNameTitleDestiny}
                titleAdressDestiny={titleAdressDestiny}
                setNameTitleArrScales={setNameTitleArrScales}
                setNameTitleEmployees={setNameTitleEmployees}
                titleAdressOrigin={titleAdressOrigin}
                setNameTitleOrigin={setNameTitleOrigin}
                selectedDestiny={selectedDestiny}
                selectedOrigin={selectedOrigin}
                setShowUnits={setShowUnits}
                setNewCreateAddressEmployee={() => {}} // Función vacía ya que no se usa en routing
                servicesView={true}
                setShowAddresses={setShowAddresses}
                showAddresses={showAddresses}
                setAddressesMarkers={setAddressesMarkers}
                addressesMarkers={addressesMarkers}
                selectedAddress={selectedAddressDestiny}
                setFindEmployees={setFindEmployees}
                findEmployees={findEmployees}
                setShowEmployees={setShowEmployees}
                typeService={{ value: "ROUTING" }} // Tipo de servicio para routing
                setArrScales={setArrScales}
                arrScales={arrScales}
                setSelectedAddress={setSelectedAddressDestiny}
                selectedAddressOrigin={selectedAddressOrigin}
                setSelectedAddressOrigin={setSelectedAddressOrigin}
                selectedAddressDestiny={selectedAddressDestiny}
                setSelectedAddressDestiny={setSelectedAddressDestiny}
                typeAddress={onFocusAddress}
                setOnFocusAddress={setOnFocusAddress}
                setSelectedDestiny={setSelectedDestiny}
                setSelectedOrigin={setSelectedOrigin}
                onMarkerClick={handleMarkerClick}
                recommendedRoutes={recommendedRoutes}
                selectedRouteIndex={selectedRouteIndex}
                onRouteClick={handleRouteClick}
              />
            </Col>
          </Row>
          <AlertSuccess
            showAlertSuccess={showAlertSuccess}
            setShowAlertSuccess={setShowAlertSuccess}
            textHeader={textHeader}
            textBody={textBody}
          />
          <AlertError
            showAlertError={showAlertError}
            setShowAlertError={setShowAlertError}
            textHeader={errorHeader}
            textBody={errorBody}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default RoutingServices;
